import { useMemo } from "react";
import { useParticipants } from "@livekit/components-react";
import { PARTICIPANT_ROLES } from "@/react/helpers/liveStreamRoomHelpers";
import type { ProviderSpectators } from "../types";
import { convertParticipantToPeer } from "./helpers";

const hasNext = () => false;
const loadPeers = () => Promise.resolve();
const loadMorePeers = () => Promise.resolve();

export const useLivekitSpectators = (): ProviderSpectators => {
  const participants = useParticipants();
  const peers = useMemo(
    () =>
      participants
        .map(convertParticipantToPeer)
        .filter(peer => peer.roleName === PARTICIPANT_ROLES.SPECTATOR),
    [participants],
  );

  return {
    peers,
    loadPeers,
    loadMorePeers,
    hasNext,
    total: peers.length,
  };
};
